import Sound from './sound';

export default Sound;
